import React from "react"
import { NavLink } from "react-router-dom"
import "./partner-shell.scss"

// Authentication context provider
import { logoutRequest } from "../../../utils/providers/auth"

// UI components
import Logo from "../../../assets/images/golf-holidays-direct-logo.png"

/**
 * App shell for third-party Stableford redemption partner accounts.
 *
 * They have two pages to be on, so the left-hand navigation buys them nothing
 * and only advertises surfaces they cannot reach. This replaces it with the
 * logo above a pair of links and a centred column, which is the whole chrome
 * the account needs.
 */
export default function PartnerShell({ children }) {
	return (
		<section id="partner-shell">
			<header className="partner-shell__header">
				<img
					className="partner-shell__logo"
					src={Logo}
					alt="Golf Holidays Direct"
				/>

				{/* The navigation carried the only way out, so it moves here */}
				<button
					type="button"
					className="partner-shell__logout"
					onClick={() => logoutRequest()}>
					Log out
				</button>
			</header>

			<nav className="partner-shell__nav">
				<NavLink exact to="/points" activeClassName="is-active">
					Redeem points
				</NavLink>

				<NavLink exact to="/points/redemptions" activeClassName="is-active">
					Redemption report
				</NavLink>
			</nav>

			<main className="partner-shell__content">{children}</main>
		</section>
	)
}
